module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logout":"Log out"},"fr":{"logout":"Déconnexion"}}')
  delete Component.options._Ctor
}
